module.exports = __webpack_public_path__ + "img/2026-boston-qr.e526810a.jpg";